import { useContext } from "react"
import { useSetRecoilState } from "recoil"

import { Views } from "../../../constants"
import {
  watchPartyScreenLinkSelector,
  watchPartyScreenSelector
} from "../../../recoil/atoms/watchPartyScreen"
import { SDKContext } from "../../../context/SDKContext"
import { viewSelector } from "../../../recoil/atoms/view"
import useConfig from "src/hooks/useConfig"
import { useHistory } from "react-router-dom"

const useHandleLeaveMeeting = () => {
  const config = useConfig()
  const history = useHistory()
  const setView = useSetRecoilState(viewSelector)
  const setWatchPartyScreen = useSetRecoilState(watchPartyScreenSelector)
  const setWatchPartyScreenLink = useSetRecoilState(
    watchPartyScreenLinkSelector
  )
  const meetingClient = useContext(SDKContext)

  const handleLeave = () => {
    setWatchPartyScreen(false)
    setWatchPartyScreenLink("")
    meetingClient?.disconnectGateway(0)
    if (config.postLoginRedirectUrl !== "") {
      history.replace(config.postLoginRedirectUrl)
    } else {
      setView(Views.BYE)
    }
  }

  return handleLeave
}

export default useHandleLeaveMeeting
